// extracted by mini-css-extract-plugin
export var divider = "_pd-0";
export var systemMessage = "_pd-1";
export var systemMessageWrapper = "_pd-2";